document.addEventListener('DOMContentLoaded', function() {
  // Wait for Recharge widget to be fully loaded
  const checkRechargeLoaded = setInterval(function() {
    const widgetContainer = document.querySelector('[data-subscription-widget], .rc_widget, .rc-widget');
    
    if (widgetContainer) {
      clearInterval(checkRechargeLoaded);
      customizeRechargeWidget();
    }
  }, 500);
  
  function customizeRechargeWidget() {
    // 1. Style the main container to match design
    const widgetContainer = document.querySelector('[data-subscription-widget], .rc_widget, .rc-widget');
    if (!widgetContainer) return;
    
    // Add styles to the container
    widgetContainer.style.backgroundColor = '#f9f8f4';
    widgetContainer.style.padding = '1.5rem';
    widgetContainer.style.borderRadius = '12px';
    
    // 2. Find the subscription options
    const subscriptionOptions = widgetContainer.querySelectorAll('input[type="radio"]');
    const optionLabels = widgetContainer.querySelectorAll('label');
    
    // 3. Style the subscription options to match design
    optionLabels.forEach(label => {
      label.style.display = 'flex';
      label.style.alignItems = 'center';
      label.style.margin = '0.75rem 0';
      label.style.fontWeight = 'normal';
    });
    
    // 4. Create a dropdown for the delivery frequency
    const frequencyButtons = Array.from(widgetContainer.querySelectorAll('[data-frequency], [data-deliver-every]'));
    
    if (frequencyButtons.length > 0) {
      // Get the parent container of the frequency buttons
      const frequencyContainer = frequencyButtons[0].parentElement;
      
      // Create dropdown label
      const dropdownLabel = document.createElement('div');
      dropdownLabel.textContent = 'Deliver every:';
      dropdownLabel.style.marginTop = '1rem';
      dropdownLabel.style.fontWeight = 'bold';
      
      // Create the select element
      const select = document.createElement('select');
      select.style.width = '100%';
      select.style.padding = '0.75rem';
      select.style.marginTop = '0.5rem';
      select.style.borderRadius = '8px';
      select.style.border = '1px solid #C35F41';
      select.style.backgroundColor = 'white';
      select.style.appearance = 'none';
      select.style.backgroundRepeat = 'no-repeat';
      select.style.backgroundPosition = 'right 1rem center';
      select.style.paddingRight = '2.5rem';
      
      // Add options based on the existing buttons
      frequencyButtons.forEach(button => {
        // Extract text content from the button
        const frequencyText = button.textContent.trim();
        const option = document.createElement('option');
        option.textContent = frequencyText;
        option.value = button.getAttribute('data-frequency') || button.getAttribute('data-deliver-every');
        select.appendChild(option);
      });
      
      // Hide the original buttons
      frequencyButtons.forEach(button => {
        button.style.display = 'none';
      });
      
      // Add event listener to select
      select.addEventListener('change', function() {
        const selectedValue = this.value;
        // Find matching button and trigger click
        const matchingButton = frequencyButtons.find(button => 
          (button.getAttribute('data-frequency') === selectedValue || 
           button.getAttribute('data-deliver-every') === selectedValue)
        );
        if (matchingButton) {
          matchingButton.click();
        }
      });
      
      // Add the dropdown to the page
      if (frequencyContainer) {
        // Add label and select
        frequencyContainer.insertBefore(dropdownLabel, frequencyContainer.firstChild);
        frequencyContainer.insertBefore(select, frequencyButtons[0]);
      }
    }
    
    // 5. Style the "Subscribe & Save" option to match design
    const subscribeOption = Array.from(optionLabels).find(label => 
      label.textContent.includes('Subscribe') || 
      label.textContent.includes('Subscription')
    );
    
    if (subscribeOption) {
      subscribeOption.style.fontWeight = 'bold';
      
      // Add discount badge
      const discountBadge = document.createElement('div');
      discountBadge.textContent = 'Save 25% on first order';
      discountBadge.style.backgroundColor = '#C35F41';
      discountBadge.style.color = 'white';
      discountBadge.style.padding = '0.5rem 1rem';
      discountBadge.style.borderRadius = '1.5rem';
      discountBadge.style.marginLeft = 'auto';
      discountBadge.style.fontSize = '0.9rem';
      
      subscribeOption.appendChild(discountBadge);
    }
    
    // 6. Add benefit checkmarks
    const benefits = [
      'Save 25% on your first order',
      'Skip, delay or cancel any time',
      'Free shipping in the US',
      'Renew on your timeframe'
    ];
    
    const benefitsList = document.createElement('div');
    benefitsList.style.marginTop = '1rem';
    benefitsList.style.marginBottom = '1rem';
    
    benefits.forEach(benefit => {
      const benefitItem = document.createElement('div');
      benefitItem.style.display = 'flex';
      benefitItem.style.alignItems = 'center';
      benefitItem.style.marginBottom = '0.5rem';
      
      // Create checkmark icon
      const checkmark = document.createElement('span');
      checkmark.innerHTML = '✓';
      checkmark.style.marginRight = '0.5rem';
      checkmark.style.color = '#C35F41';
      checkmark.style.fontWeight = 'bold';
      
      const text = document.createElement('span');
      text.textContent = benefit;
      
      benefitItem.appendChild(checkmark);
      benefitItem.appendChild(text);
      benefitsList.appendChild(benefitItem);
    });
    
    // Find where to insert the benefits list
    if (subscribeOption) {
      const subscribeParent = subscribeOption.closest('div, form');
      if (subscribeParent) {
        subscribeParent.appendChild(benefitsList);
      }
    }
    
    // 7. Add "Learn more" link
    const learnMore = document.createElement('a');
    learnMore.textContent = 'Learn more';
    learnMore.href = '#';
    learnMore.style.color = '#C35F41';
    learnMore.style.textDecoration = 'none';
    learnMore.style.marginBottom = '1.5rem';
    learnMore.style.display = 'block';
    
    if (benefitsList) {
      benefitsList.appendChild(learnMore);
    }
  }
});